import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { TopNavigationAction, Icon } from '@ui-kitten/components';
import { useScreenDimensions } from '../../utils/useScreenInfo';

const MenuIcon = (style: any) => <Icon {...style} name='menu-outline' height={30} width={30} fill='rgb(143, 155, 179)' />;

export function MenuAction() {
    const navigation: any = useNavigation<any>();
    return (
        <TopNavigationAction
            icon={MenuIcon}
            onPress={() => navigation.openDrawer()}
            style={{ marginLeft: 5, padding: 10 }}
        />
    );
}

export function getMenuAction(alwaysShow?: boolean) {
    const { isLargeScreenOrLarger } = useScreenDimensions();
    let screenOptions: any = { };
    if (alwaysShow || !isLargeScreenOrLarger) {
        screenOptions.headerLeft = () => <MenuAction />;
    }

    return screenOptions;
}


